import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'

import { Input, LookingToJoin, Form, Main } from '../../../components'
import { PasswordInput } from '../../../components/Forms/Password'
import { getUser, submitUserPassword } from './state'
import { FormattedMessage, useIntl } from 'react-intl'

type PasswordData = {
  password: string
}

export function CredentialsForm({ superEnabled }: { superEnabled: boolean }) {
  const intl = useIntl()
  const dispatch = useDispatch()
  const user = useSelector(getUser)
  const { control, formState, handleSubmit } = useForm<PasswordData>({
    mode: 'onChange',
    defaultValues: { password: '' },
  })
  const onSubmit = ({ password }: PasswordData) => {
    dispatch(submitUserPassword(password))
  }

  return (
    <Main.Container footer={<LookingToJoin superEnabled={superEnabled} />}>
      <Main.Title>
        <FormattedMessage
          id="boarding.joinOrg.password.title"
          defaultMessage="Set your password"
          values={{}}
        />
      </Main.Title>
      <form
        className="flexbox flexbox-column form-grid"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div>
          <Form.Label>
            <FormattedMessage
              id="boarding.joinOrg.type.email"
              defaultMessage="Your work email"
              values={{}}
            />
          </Form.Label>
          <Input
            id="email"
            type="email"
            value={user.email}
            disabled
            className="margin-vertical-8"
          />
        </div>
        <div>
          <Form.Label>
            <FormattedMessage
              id="boarding.joinOrg.choosePassword"
              defaultMessage="Choose a password"
              values={{}}
            />
          </Form.Label>
          <PasswordInput<PasswordData> name="password" control={control} />
        </div>
        <Form.Button disabled={!formState.isValid}>
          {intl.formatMessage({
            id: 'boarding.joinOrg.next',
            defaultMessage: 'Continue',
          })}
        </Form.Button>
      </form>
    </Main.Container>
  )
}
